import { render, staticRenderFns } from "./bloodpressure.vue?vue&type=template&id=0b25a4b8"
import script from "./bloodpressure.vue?vue&type=script&lang=js"
export * from "./bloodpressure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports